// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"041299f2","400":"349d1b57","696":"45686008","808":"582aaab0","856":"e94e9bb3","952":"3030de8a"}[chunkId] + ".chunk.js";
};